import React, { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import GlobalHeaderTitle from '../../components/GlobalHeaderTitle';
import ExamCalendarSettings from './parts/ExamCalendarSettings';
import FormTeacherSettings from './parts/FormTeacherSettings';
import TimetableSettings from './parts/TimetableSettings';
import FeesReminderSettings from './parts/FeesReminderSettings';
import SchoolProfileSettings from './parts/SchoolProfileSettings';
import RoleAccessSettings from './parts/RoleAccessSettings';
import AttendanceSetupSettings from './parts/AttendanceSetupSettings';
import CombinedFormTeacherSettings from './parts/CombinedFormTeacherSettings';

interface Tab {
  id: string;
  label: string;
  icon: string;
}

const TABS: Tab[] = [
  { id: 'school',       label: 'School Profile',   icon: 'pi pi-building'       },
  { id: 'timetable',   label: 'Timetable',         icon: 'pi pi-calendar'       },
  { id: 'exams',       label: 'Exam Calendar',     icon: 'pi pi-book'           },
  { id: 'teacher',     label: 'Teacher`s Access',      icon: 'pi pi-user'           },
  { id: 'fees',        label: 'Fees Control',     icon: 'pi pi-bell'           },
  { id: 'attendancesetup',  label: 'Attendance Setup',       icon: 'pi pi-shield'         },
  { id: 'CombinedFormTeacherSettings',  label: 'Combined Form Teacher',       icon: 'pi pi-shield'         },
];

const SettingsPage: React.FC = () => {
  const toast = useRef<Toast>(null);
  const [activeTab, setActiveTab] = useState<string>('school');

  return (
    <>
      <Toast ref={toast} position="top-right" />

      <div style={{ minHeight: '100vh', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
        <GlobalHeaderTitle
          title="System Settings"
          subtitle="Manage your system preferences and configurations"
          icon="pi pi-cog"
        />

        {/* Tab Bar */}
        <div style={{
          display: 'flex',
          gap: '4px',
          marginBottom: '24px',
          background: 'white',
          borderRadius: '14px',
          padding: '6px',
          boxShadow: '0 2px 8px rgba(30,64,175,0.08)',
          border: '1px solid rgba(59,130,246,0.12)',
          flexWrap: 'wrap',
        }}>
          {TABS.map((tab) => {
            const active = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '7px',
                  padding: '9px 16px',
                  borderRadius: '10px',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: active ? '700' : '500',
                  background: active ? 'linear-gradient(135deg,#1e40af 0%,#3b82f6 100%)' : 'transparent',
                  color: active ? 'white' : '#64748b',
                  boxShadow: active ? '0 2px 8px rgba(59,130,246,0.25)' : 'none',
                  transition: 'all 0.15s',
                  whiteSpace: 'nowrap',
                }}
              >
                <i className={tab.icon} style={{ fontSize: '13px' }} />
                {tab.label}
              </button>
            );
          })}
        </div>

        {/* Tab Content */}
        <div>
          {activeTab === 'school'      && <SchoolProfileSettings />}
          {activeTab === 'timetable'  && <TimetableSettings />}
          {activeTab === 'exams'      && <ExamCalendarSettings />}
          {activeTab === 'teacher'    && <FormTeacherSettings />}
          {activeTab === 'fees'       && <FeesReminderSettings />}
          {activeTab === 'attendancesetup' && <AttendanceSetupSettings />}
          {activeTab === 'CombinedFormTeacherSettings' && <CombinedFormTeacherSettings />}
        </div>
      </div>
    </>
  );
};

export default SettingsPage;